module.exports = __webpack_public_path__ + "static/media/meadow.0abc6fd3.png";